import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const MeetingHistory = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M4.44 19h13.59a2 2 0 0 0 1.909-1.404l1.655-5.298A1 1 0 0 0 20.64 11H20M4.44 19c.63 0 1.188-.41 1.376-1.011l1.745-5.586A2 2 0 0 1 9.471 11H20M4.44 19A1.44 1.44 0 0 1 3 17.56V6a2 2 0 0 1 2-2h3.93a2 2 0 0 1 1.664.89l1.11 1.665a1 1 0 0 0 .831.445H18a2 2 0 0 1 2 2v2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 3.25A2.75 2.75 0 0 0 2.25 6v11.56c0 1.21.98 2.19 2.19 2.19h13.59a2.75 2.75 0 0 0 2.624-1.93l1.656-5.298a1.75 1.75 0 0 0-1.56-2.269V9A2.75 2.75 0 0 0 18 6.25h-5.465a.25.25 0 0 1-.208-.111l-1.11-1.664A2.75 2.75 0 0 0 8.93 3.25zm4.47 7h9.78V9c0-.69-.56-1.25-1.25-1.25h-5.465a1.75 1.75 0 0 1-1.456-.78L9.97 5.308a1.25 1.25 0 0 0-1.04-.557H5c-.69 0-1.25.56-1.25 1.25v11.56a.69.69 0 0 0 1.35.205l1.746-5.585a2.75 2.75 0 0 1 2.624-1.93'
        fill='currentColor'
      />
    )}
  </IconBase>
);
